import React, { useEffect, useState } from 'react';
import { Route, Routes, Link, useNavigate } from 'react-router-dom';
import Navigation from '../../customer/Components/Navbar/Navigation';
import "./Dashboard.css"
import Order from './Component/Order';
import Profile from "./Component/Profile"
import Favorites from './Component/Wishlist';
// import { useDispatch, useSelector } from 'react-redux';
// import { jwtDecode } from 'jwt-decode';
// import { fetchUserById, signoutUser, updateUser } from '../Redux/User/userSlice';
import Sidebar from '../../customer/Components/Sidebar/Sidebar';

const MyProfilePage = () => {


  return (
    <div className="flex flex-col  ">
      <Navigation />
      <div className='flex mt-[-41px]'>
      <Sidebar />
      <div className="flex-1 ml-2 lg:ml-0 overflow-scroll h-[86vh] bg-slate-200">
  
        <Routes>
          <Route path="/profile" element={<Profile/>} />
          <Route path="/order" element={<Order/>} />
          <Route path="/wishlist" element={<Favorites/>} />
          {/* <Route path="manage-addresses" element={<ManageAddresses />} />
          <Route path="pan-card-information" element={<PanCardInformation />} />
          <Route path="gift-cards" element={<GiftCards />} />
          <Route path="saved-upi" element={<SavedUPI />} />
          <Route path="saved-cards" element={<SavedCards />} />
          <Route path="my-coupons" element={<MyCoupons />} />
          <Route path="my-reviews-ratings" element={<MyReviewsRatings />} />
          <Route path="all-notifications" element={<AllNotifications />} />
          <Route path="my-wishlist" element={<MyWishlist />} />
   
          <Route path="track-order" element={<OrderTrackingPage/>}/> */}
        </Routes>
      </div>
      </div>

    </div>
  );
};

export default MyProfilePage;
